module.exports = __webpack_public_path__ + "img/corporate_frames.3c8b68d8.png";